import { useRef, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { saveToGlobalState } from "../../utils/localStorage";
import { useAuth } from "../../context/AuthContext";

const API_URL = process.env.REACT_APP_API_URL;

const STORAGE_KEY = "confirmation_token";

const CHECK_AVAILABILITY_URL = `${API_URL}/api/users/check-availability/`;

const initialForm = {
  img: "",
  name: "",
  email: "",
  date_birth: "",
  phone: "",
  cpf: "",
  type_pix: "",
  key_pix: "",
  current_password: "",
  new_password: "",
  repeat_password: "",
};

export default function UseMyProfile() {
  const navigate = useNavigate();
  const location = useLocation();

  const { user, authFetch, setUser } = useAuth();

  const maskCPF = (value) => {
    if (!value) return "";
    value = value.replace(/\D/g, "");
    value = value.slice(0, 11);
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    return value;
  };

  const [form, setForm] = useState({
    ...initialForm,

    img: `${API_URL}${user?.identificacao}` || "",
    name: user?.nome || "",
    email: user?.email || "",
    phone: user?.telefone || "",
    cpf: maskCPF(user?.cpf) || "",
    date_birth: user?.data_nascimento?.split("-").reverse().join("/") || "",
    type_pix: user?.tipo_pix || "",
    key_pix: user?.chave_pix || "",
    current_password: "",
    new_password: "",
    repeat_password: "",
  });
  const [fieldErrors, setFieldErrors] = useState({});
  const [filePreview, setFilePreview] = useState("");
  const [file, setFile] = useState(null);
  const [colorMsgfile, setColorMsgfile] = useState("");
  const [fileUploadedSucessfully, setFileUploadedSucessfully] = useState("");
  const [updatePassword, setUpdatePassword] = useState("");
  const [colorMsgPassword, setColorMsgPassword] = useState("");
  const [passwordLoading, setPasswordLoading] = useState(false);

  const [updatePersonalData, setUpdatePersonalData] = useState("");
  const [colorMsgPersonalData, setColorMsgPersonalData] = useState("");
  const [personalDataLoading, setPersonalDataLoading] = useState(false);
  const [pixOpen, setPixOpen] = useState(false);

  const pixOptions = ["Email", "Telefone", "CPF/CNPJ", "Chave aleatória"];

  const fileInputRef = useRef(null);

  useEffect(() => {
    return () => {
      if (filePreview) {
        URL.revokeObjectURL(filePreview);
      }
    };
  }, [filePreview]);

  const cleanCPF = (value) => value.replace(/\D/g, "");

  const maskDate = (value) => {
    value = value.replace(/\D/g, "");
    value = value.slice(0, 8);
    value = value.replace(/(\d{2})(\d)/, "$1/$2");
    value = value.replace(/(\d{2})(\d)/, "$1/$2");
    return value;
  };

  const validateCPF = (cpf) => {
    cpf = cpf.replace(/\D/g, "");

    if (cpf.length !== 11) return false;
    if (/^(\d)\1+$/.test(cpf)) return false;

    let sum = 0;
    let rest;

    for (let i = 1; i <= 9; i++) {
      sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
    }

    rest = (sum * 10) % 11;
    if (rest === 10 || rest === 11) rest = 0;
    if (rest !== parseInt(cpf.substring(9, 10))) return false;

    sum = 0;
    for (let i = 1; i <= 10; i++) {
      sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
    }

    rest = (sum * 10) % 11;
    if (rest === 10 || rest === 11) rest = 0;
    if (rest !== parseInt(cpf.substring(10, 11))) return false;

    return true;
  };

  const validateEmail = (email) => {
    const value = email.trim();

    if (!value) return "Email é obrigatório";

    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(value)) return "Email inválido";

    return "";
  };

  const validatePhone = (phone) => {
    const digits = phone.replace(/\D/g, "");

    if (!digits) return "Telefone é obrigatório";
    if (digits.length < 10 || digits.length > 11) return "Telefone inválido";

    return "";
  };

  const validatePassword = (password) => {
    if (!password) return "";
    if (password.length < 8) return "Senha deve ter pelo menos 8 caracteres";
    if (!/[A-Z]/.test(password)) return "Senha deve conter 1 letra maiúscula";
    if (!/[a-z]/.test(password)) return "Senha deve conter 1 letra minúscula";
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/.test(password)) {
      return "Senha deve conter um símbolo";
    }

    return "";
  };

  const validateRepeatPassword = (password, repeatPassword) => {
    if (!repeatPassword) return "Confirmação de senha é obrigatória";
    if (password !== repeatPassword) return "As senhas não coincidem";
    return "";
  };

  const validateBirthDate = (dateStr) => {
    if (!dateStr || dateStr.length !== 10) {
      return "Data de nascimento inválida";
    }

    const [dd, mm, yyyy] = dateStr.split("/");
    const birthDate = new Date(`${yyyy}-${mm}-${dd}T00:00:00`);

    if (isNaN(birthDate.getTime())) {
      return "Data de nascimento inválida";
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    birthDate.setHours(0, 0, 0, 0);

    if (birthDate >= today) {
      return "Data de nascimento inválida";
    }

    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    const finalAge =
      monthDiff < 0 || (monthDiff === 0 && dayDiff < 0) ? age - 1 : age;

    if (finalAge < 18) {
      return "Você precisa ter pelo menos 18 anos";
    }

    return "";
  };

  const validateCpfField = (cpf) => {
    const raw = cpf.replace(/\D/g, "");
    if (!raw) return "CPF é obrigatório";
    if (raw.length !== 11) return "CPF inválido";
    return validateCPF(raw) ? "" : "CPF inválido";
  };

  const checkAvailability = async (field, value) => {
    if (!API_URL) return "";

    const normalizedField =
      field === "phone"
        ? "telefone"
        : field === "key_pix"
          ? "chave_pix"
          : field === "current_password"
            ? "password"
            : field === "new_password"
              ? "password"
              : field;

    const isSameAsUser =
      (normalizedField === "email" && value === user?.email) ||
      (normalizedField === "telefone" && value === user?.telefone) ||
      (normalizedField === "cpf" && value === user?.cpf) ||
      (normalizedField === "chave_pix" && value === user?.chave_pix);

    if (isSameAsUser) return "";

    try {
      const response = await authFetch(
        `${CHECK_AVAILABILITY_URL}?field=${encodeURIComponent(normalizedField)}&value=${encodeURIComponent(value)}`,
        {
          method: "GET",
          headers: {
            //Authorization: `Bearer ${accessToken}`,
          },
        },
      );

      if (!response.ok) return "";

      const data = await response.json();

      if (field === "current_password" && normalizedField === "password") {
        return data?.valid ? "" : data?.message || "Senha atual incorreta";
      }

      if (field === "new_password" && normalizedField === "password") {
        return data?.valid ? "A nova senha não pode ser igual a anterior" : "";
      }

      const exists =
        data?.exists === true ||
        data?.taken === true ||
        data?.available === false;

      if (!exists) return "";
      if (field === "email") return data?.message || "Email já cadastrado";
      if (field === "cpf") return data?.message || "CPF já cadastrado";
      if (field === "phone") return data?.message || "Telefone já cadastrado";
      if (field === "key_pix")
        return data?.message || "Chave pix já cadastrada";

      return data?.message || "Já existe um cadastro com esse valor";
    } catch {
      return "";
    }
  };

  const syncPasswordErrors = (nextForm) => {
    setFieldErrors((prev) => {
      const next = { ...prev };

      const passwordError = validatePassword(nextForm.new_password);
      if (passwordError) {
        next.new_password = passwordError;
      } else if (
        next.new_password &&
        next.new_password === "Senha é obrigatória"
      ) {
        next.new_password = "";
      }

      if (!nextForm.new_password || !nextForm.repeat_password) {
        next.repeat_password = "";
      } else {
        const repeatError = validateRepeatPassword(
          nextForm.new_password,
          nextForm.repeat_password,
        );

        next.repeat_password = repeatError;
      }

      return next;
    });
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));

    setFieldErrors((prev) => ({
      ...prev,
      [field]: "",
    }));

    if (field === "new_password" || field === "repeat_password") {
      setTimeout(() => {
        setForm((current) => {
          syncPasswordErrors({
            ...current,
            [field]: value,
          });

          return current;
        });
      }, 0);
    }
  };

  const validateField = async (field) => {
    let message = "";

    switch (field) {
      case "name":
        message = form.name.trim() ? "" : "Nome é obrigatório";
        break;

      case "email":
        message = validateEmail(form.email);
        if (!message) {
          const availabilityError = await checkAvailability(
            "email",
            form.email.trim(),
          );
          message = availabilityError;
        }
        break;

      case "date_birth":
        message = validateBirthDate(form.date_birth);
        break;

      case "phone":
        message = validatePhone(form.phone);
        if (!message) {
          const availabilityError = await checkAvailability(
            "phone",
            form.phone,
          );
          message = availabilityError;
        }
        break;

      case "cpf":
        message = validateCpfField(form.cpf);
        if (!message) {
          const availabilityError = await checkAvailability(
            "cpf",
            cleanCPF(form.cpf),
          );
          message = availabilityError;
        }
        break;

      case "type_pix":
        message = form.type_pix.trim() ? "" : "Tipo PIX é obrigatório";
        break;

      case "key_pix":
        message = form.key_pix.trim() ? "" : "Chave PIX é obrigatória";
        if (!message) {
          const availabilityError = await checkAvailability(
            "key_pix",
            form.key_pix.trim(),
          );
          message = availabilityError;
        }
        break;

      case "current_password":
        message = validatePassword(form.current_password);
        if (!message) {
          const availabilityError = await checkAvailability(
            "current_password",
            form.current_password,
          );
          message = availabilityError;
        }
        break;

      case "new_password":
        message = validatePassword(form.new_password);
        if (!message) {
          const availabilityError = await checkAvailability(
            "new_password",
            form.new_password,
          );
          message = availabilityError;
        }
        break;

      case "repeat_password":
        message = validateRepeatPassword(
          form.new_password,
          form.repeat_password,
        );
        break;

      default:
        break;
    }

    setFieldErrors((prev) => ({
      ...prev,
      [field]: message,
    }));

    return message;
  };

  const handleCpfChange = (value) => {
    const masked = maskCPF(value);
    handleChange("cpf", masked);
  };

  const handleDateChange = (value) => {
    handleChange("date_birth", maskDate(value));
  };

  const handlePhoneChange = (value) => {
    let raw = value.replace(/\D/g, "");
    if (raw.length > 11) raw = raw.slice(0, 11);

    raw = raw.replace(/^(\d{2})(\d)/, "($1) $2");
    raw = raw.replace(/(\d{5})(\d)/, "$1-$2");

    handleChange("phone", raw);
  };

  const openFilePicker = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files?.[0];

    if (!selectedFile) return;

    setFile(selectedFile);

    const previewURL = URL.createObjectURL(selectedFile);

    const payloadImageProfile = new FormData();
    payloadImageProfile.append("imageProfile", selectedFile);

    const response = await authFetch(
      `${API_URL}/api/users/update-image-profile/`,
      {
        method: "PATCH",
        credentials: "include",
        headers: {
          //Authorization: `Bearer ${accessToken}`,
        },
        body: payloadImageProfile,
      },
    );

    if (!response.ok) {
      setFileUploadedSucessfully("Ocorreu um erro, tente novamente!");
      setColorMsgfile("rgb(200, 30, 30)");
      setTimeout(() => {
        setFileUploadedSucessfully("");
        //window.location.reload();
      }, 2000);
      return;
    }

    setFilePreview(previewURL);

    setFileUploadedSucessfully("Perfil editado com sucesso");
    setColorMsgfile("#0bb96bff");
    setTimeout(() => {
      setFileUploadedSucessfully("");
      //window.location.reload();
    }, 2000);
  };

  const validatePasswordForm = async () => {
    const fieldsToValidate = [
      "current_password",
      "new_password",
      "repeat_password",
    ];

    for (const field of fieldsToValidate) {
      const error = await validateField(field);
      if (error) return error;
    }

    return null;
  };

  const validatePersonalDataForm = async () => {
    const fieldsToValidate = [
      "name",
      "email",
      "date_birth",
      "phone",
      "cpf",
      "type_pix",
      "key_pix",
    ];

    for (const field of fieldsToValidate) {
      const error = await validateField(field);
      if (error) return error;
    }

    return null;
  };

  const handlePasswordSubmit = async () => {
    if (
      !form.current_password?.trim() ||
      !form.new_password?.trim() ||
      !form.repeat_password?.trim()
    ) {
      return;
    }
    try {
      setPasswordLoading(true);

      const error = await validatePasswordForm();

      if (error) {
        setUpdatePassword(error);
        setColorMsgPassword("rgb(200, 30, 30)");
        setPasswordLoading(false);
        setTimeout(() => {
          setUpdatePassword("");
        }, 2000);
        return;
      }
      setPasswordLoading(false);

      const response = await authFetch(
        `${API_URL}/api/users/update-password/`,
        {
          method: "PATCH",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            //Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            current_password: form.current_password,
            new_password: form.new_password,
          }),
        },
      );

      const data = await response.json();

      if (!response.ok) {
        setPasswordLoading(false);
        setUpdatePassword("Erro ao alterar a senha, tente novamente!");
        setColorMsgPassword("rgb(200, 30, 30)");
        setTimeout(() => {
          setUpdatePassword("");
          window.location.reload();
        }, 2000);
        return;
      }

      setUpdatePassword("Senha alterada com sucesso!");
      setColorMsgPassword("#0bb96bff");
      setTimeout(() => {
        setUpdatePassword("");
      }, 2000);
      form.current_password = "";
      form.new_password = "";
      form.repeat_password = "";
      setPasswordLoading(false);
    } catch (err) {
      setPasswordLoading(false);
    }
  };

  const handlePersonalDataSubmit = async () => {
    if (
      !form.name?.trim() ||
      !form.email?.trim() ||
      !form.date_birth?.trim() ||
      !form.phone?.trim() ||
      !form.cpf?.trim() ||
      !form.type_pix?.trim() ||
      !form.key_pix?.trim()
    ) {
      return;
    }
    try {
      setPersonalDataLoading(true);

      const error = await validatePersonalDataForm();

      if (error) {
        setUpdatePersonalData(error);
        setColorMsgPersonalData("rgb(200, 30, 30)");
        setPersonalDataLoading(false);
        setTimeout(() => {
          setUpdatePersonalData("");
        }, 2000);
        return;
      }

      const payloadPersonalData = {
        name: form.name,
        email: form.email,
        date_birth: form.date_birth,
        phone: form.phone,
        cpf: cleanCPF(form.cpf),
        type_pix: form.type_pix,
        key_pix: form.key_pix,
      };

      const response = await authFetch(
        `${API_URL}/api/users/update-personal-data/`,
        {
          method: "PATCH",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            //Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(payloadPersonalData),
        },
      );

      const data = await response.json();

      if (!response.ok) {
        setPersonalDataLoading(false);
        setUpdatePersonalData(
          "Erro alterar os dados pessoais, tente novamente!",
        );
        setColorMsgPersonalData("rgb(200, 30, 30)");
        setTimeout(() => {
          setUpdatePersonalData("");
          //window.location.reload();
        }, 2000);
        return;
      }

      setUpdatePersonalData("Dados pessoais alterados com sucesso!");
      setColorMsgPersonalData("#0bb96bff");
      setTimeout(() => {
        setUpdatePersonalData("");

        if (data.email_changed && data.phone_changed) {
          saveToGlobalState({
            tab_login: "PERFIL",
            edit_profile: 1,
            confirmation_token: data.confirmation_token,
          });
          navigate("/confirmacao-email", {
            state: {
              email: data.email,
              telefone: data.phone,
              phone_confirmation: false,
            },
          });
          return;
        }

        if (data.email_changed) {
          saveToGlobalState({
            tab_login: "PERFIL",
            edit_profile: 1,
            confirmation_token: data.confirmation_token,
          });
          navigate("/confirmacao-email", {
            state: {
              email: data.email,
              telefone: data.phone,
              phone_confirmation: true,
            },
          });
          return;
        }

        if (data.phone_changed) {
          saveToGlobalState({
            tab_login: "PERFIL",
            edit_profile: 1,
            confirmation_token: data.confirmation_token,
          });
          navigate("/confirmacao-telefone", {
            state: {
              telefone: data.phone,
            },
          });
          return;
        }

        window.location.reload();
      }, 2000);

      setPersonalDataLoading(false);
    } catch (err) {
      setPersonalDataLoading(false);
    }
  };

  return {
    user,
    form,
    fieldErrors,
    filePreview,
    colorMsgfile,
    fileUploadedSucessfully,
    updatePassword,
    colorMsgPassword,
    passwordLoading,
    updatePersonalData,
    setUpdatePersonalData,
    colorMsgPersonalData,
    setColorMsgPersonalData,
    personalDataLoading,
    fileInputRef,
    handleChange,
    handleCpfChange,
    handleDateChange,
    handlePhoneChange,
    handleFileChange,
    openFilePicker,
    pixOpen,
    setPixOpen,
    pixOptions,
    handlePasswordSubmit,
    handlePersonalDataSubmit,
    validateField,
  };
}
